<div
  class="container slide-in-left"
  [class.container-toggled]="toggleService.isToggled"
  (mouseleave)="toggleService.toggleSidebar()"
  (mouseenter)="toggleService.toggleSidebar()"
>
  <div class="termhub-logo-text" (click)="navigateToTH()" [class.logo-toggled]="toggleService.isToggled" id="sidebarTHLink">
    <span *ngIf="!toggleService.isToggled">
      <img src="../../assets/termhub-logo.png" alt="Termhub" class="untoggled" title="{{ server_version }}" />
    </span>
    <span *ngIf="toggleService.isToggled">
      <img src="../../assets/termhub-short-logo.png" alt="Termhub" height="20" title="{{ server_version }}" />
    </span>
  </div>

  <ng-container [ngSwitch]="server_environment">
    <div *ngSwitchCase="'localhost'" class="banner text-white local page-h1-font"></div>
    <div *ngSwitchCase="'demo'" class="banner text-white dev page-h1-font"></div>
    <div *ngSwitchCase="'uat'" class="banner text-white uat page-h1-font"></div>
    <div *ngSwitchCase="'training'" class="banner text-white training page-h1-font"></div>
    <div *ngSwitchDefault class="banner text-white d-none page-h1-font"></div>
  </ng-container>

  <div class="sidebar-menu-items">
    <div>
      <div class="menu-item-main">
        <div
          id="sidebarDashboardLink"
          class="d-flex align-items-center"
          [routerLink]="['/dashboard']"
          [ngClass]="{
            'active active-fill': location.path().includes('/dashboard'),
          }"
          (click)="removeClassToBodyForResponsiveMenu()"
        >
          <div class="icon" title="Dashboard">
            <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="var(--grey-icon-color)">
              <path
                d="M520-600v-240h320v240H520ZM120-440v-400h320v400H120Zm400 320v-400h320v400H520Zm-400 0v-240h320v240H120Zm80-400h160v-240H200v240Zm400 320h160v-240H600v240Zm0-480h160v-80H600v80ZM200-200h160v-80H200v80Zm160-320Zm240-160Zm0 240ZM360-280Z"
              />
            </svg>
          </div>
          <div class="menu-item" *ngIf="!toggleService.isToggled">Dashboard</div>
        </div>
      </div>

      <div class="menu-item-main">
        <div
          id="sidebarOrganizationsLink"
          class="d-flex align-items-center"
          [routerLink]="['/organizations']"
          [ngClass]="{
            'active active-stroke':
              ((location.path().split('/').length === 2 || location.path().split('/').length === 3) && location.path().includes('organizations')) ||
              location.path().includes('/edit-organization') ||
              (location.path().includes('organizations') && location.path().includes('users') && !location.path().includes('projects')),
          }"
          (click)="removeClassToBodyForResponsiveMenu()"
        >
          <div class="icon" title="Organizations">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.2 6.4H8.8V4.8H7.2V6.4ZM7.2 9.6H8.8V8H7.2V9.6ZM8.8 14.4V11.2H7.2V14.4H4.8V4H7.2H8.8H11.2V14.4H8.8ZM14.4 12.8V14.4H12.8V2.4H11.2H8.8V0H7.2V2.4H4.8H3.2V14.4H1.6V12.8H0V14.4V16H3.2H4.8H11.2H12.8H16V14.4V12.8H14.4Z"
                stroke="var(--grey-icon-color)"
                stroke-width="1.4"
              />
            </svg>
          </div>
          <div class="menu-item" *ngIf="!toggleService.isToggled">Organizations</div>
        </div>
      </div>

      <div class="menu-item-main">
        <div
          id="sidebarProjectsLink"
          class="d-flex align-items-center"
          [routerLink]="['/projects']"
          [ngClass]="{
            'active active-fill':
              (location.path().includes('/projects') && !location.path().includes('teams')) || location.path().includes('/new-project'),
          }"
          (click)="removeClassToBodyForResponsiveMenu()"
        >
          <div class="icon" title="Projects">
            <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="var(--grey-icon-color)">
              <path
                d="M200-520q-33 0-56.5-23.5T120-600v-160q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v160q0 33-23.5 56.5T760-520H200Zm0-80h560v-160H200v160Zm0 480q-33 0-56.5-23.5T120-200v-160q0-33 23.5-56.5T200-440h560q33 0 56.5 23.5T840-360v160q0 33-23.5 56.5T760-120H200Zm0-80h560v-160H200v160Zm0-560v160-160Zm0 400v160-160Z"
              />
            </svg>
          </div>
          <div class="menu-item" *ngIf="!toggleService.isToggled">Projects</div>
        </div>
      </div>

      <div class="menu-item-main">
        <div
          id="sidebarTeamsLink"
          class="d-flex align-items-center"
          [routerLink]="['/teams']"
          [ngClass]="{
            'active active-fill-svg':
              location.path().includes('/teams') || location.path().includes('/new-team') || location.path().includes('/edit-team'),
          }"
          (click)="removeClassToBodyForResponsiveMenu()"
        >
          <div class="icon" title="Teams">
            <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                class="fill-svg"
                d="M16.5 13c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25zm-4 4.5h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25zm9 0H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25zM7.5 12c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"
                fill="var(--grey-icon-color)"
                stroke-width=".2"
              />
            </svg>
          </div>
          <div class="menu-item" *ngIf="!toggleService.isToggled">Teams</div>
        </div>
      </div>

      <hr />

      <div class="menu-item-main">
        <div
          id="sidebarResourcesLink"
          class="d-flex align-items-center"
          [routerLink]="['/resources']"
          [ngClass]="{ 'active active-fill': location.path().includes('/resources') }"
          (click)="removeClassToBodyForResponsiveMenu()"
        >
          <div class="icon" title="Resources">
            <i class="fa-solid fa-book sidebar-icon"></i>
          </div>
          <div class="menu-item" *ngIf="!toggleService.isToggled">Resources</div>
        </div>
      </div>

      <div class="menu-item-main">
        <div
          id="sidebarTerminologiesLink"
          class="d-flex align-items-center"
          [routerLink]="['/terminologies']"
          [ngClass]="{ 'active active-fill': location.path().includes('/terminologies') || location.path().includes('/mapsets') }"
          (click)="removeClassToBodyForResponsiveMenu()"
        >
          <div class="icon" title="Terminologies">
            <i class="fa-solid fa-sitemap sidebar-icon"></i>
          </div>
          <div class="menu-item" *ngIf="!toggleService.isToggled">Terminologies</div>
        </div>
      </div>

      <hr *ngIf="isAdmin" />

      <div class="menu-item-main" *ngIf="isAdmin">
        <div
          id="sidebarConfigLink"
          class="d-flex align-items-center"
          [routerLink]="['/config']"
          [ngClass]="{ 'active active-fill': location.path().includes('/config') }"
          (click)="removeClassToBodyForResponsiveMenu()"
        >
          <div class="icon" title="Config">
            <i class="fa-solid fa-gear sidebar-icon"></i>
          </div>
          <div class="menu-item" *ngIf="!toggleService.isToggled">Config</div>
        </div>
      </div>

      <div class="menu-item-main" *ngIf="isAdmin">
        <div
          id="sidebarUsersLink"
          class="d-flex align-items-center"
          [routerLink]="['/users']"
          [ngClass]="{ 'active active-fill': location.path().includes('/users') }"
          (click)="removeClassToBodyForResponsiveMenu()"
        >
          <div class="icon" title="Users">
            <i class="fa-solid fa-users sidebar-icon"></i>
          </div>
          <div class="menu-item" *ngIf="!toggleService.isToggled">Users</div>
        </div>
      </div>
      <div class="menu-item-main" *ngIf="isAdmin">
        <div
          id="sidebarMetricsLink"
          class="d-flex align-items-center"
          [routerLink]="['/metrics']"
          [ngClass]="{ 'active active-fill': location.path().includes('/metrics') }"
          (click)="removeClassToBodyForResponsiveMenu()"
        >
          <div class="icon" title="Metrics">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path
                d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm96 288H448c17.7 0 32-14.3 32-32V251.8c0-7.6-2.7-15-7.7-20.8l-65.8-76.8c-12.1-14.2-33.7-15-46.9-1.8l-21 21c-10 10-26.4 9.2-35.4-1.6l-39.2-47c-12.6-15.1-35.7-15.4-48.7-.6L135.9 215c-5.1 5.8-7.9 13.3-7.9 21.1v84c0 17.7 14.3 32 32 32z"
                fill="var(--grey-icon-color)"
              />
            </svg>
          </div>
          <div class="menu-item" *ngIf="!toggleService.isToggled">Metrics</div>
        </div>
      </div>
    </div>
    <div class="menu-align-bottom sidebar-menu" [ngClass]="{ 'menu-align-bottom-admin': isAdmin }">
      <div class="menu-item-main">
        <div class="d-flex align-items-center">
          <app-user-notifications></app-user-notifications>
          <div *ngIf="!toggleService.isToggled" class="menu-item">Notifications</div>
        </div>
      </div>
      <div class="menu-item-main">
        <div class="d-flex align-items-center">
          <app-user-menu></app-user-menu>
          <div *ngIf="!toggleService.isToggled" class="menu-item user-title-font">{{ userService.userData.name }}</div>
        </div>
      </div>
    </div>
    <div id="sidebarTHCopyLink" class="copyright" *ngIf="!toggleService.isToggled">
      ©{{ this.currentYear }} <span class="default-link" (click)="navigateToTH()">TermHub™</span>
      <p>All Rights Reserved</p>
    </div>
  </div>
</div>
